export default "__VITE_ASSET__BUAVHFgt__"